import { render, staticRenderFns } from "./TheModalEstadoPaciente.vue?vue&type=template&id=558473d5&"
import script from "./TheModalEstadoPaciente.vue?vue&type=script&lang=js&"
export * from "./TheModalEstadoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports